import React, {Component} from 'react';
import GroupView from './GroupView'
import {Grid, Row, Col} from 'react-bootstrap'
import CreateGroupModal from './CreateGroupModal'
import AddUserModal from './Users/AddUserModal'
import blueAdd from '../../../../resources/images/dark_blue_add.png'
import {retrieveUsersInGroup, removeUserFromGroup, addUserRole, removeUserRole, deleteUser} from '../../../actions/index'

export default class GroupsView extends Component {

    constructor(props) {
        super(props)

        this.state = {
            showCreateGroupModal: false,
            selectedGroup: undefined,
            showAddUserModal: false
        }
    }

    selectGroup = (group) => {
        //console.log('selectGroup', group)
        this.props.dispatch(retrieveUsersInGroup(group.id))
        this.setState({
            selectedGroup: group
        })
    }

    _removeUserFromGroup = (groupId, userId) => {
        //console.log('_removeUserFromGroup', groupId, userId)
        this.props.dispatch(removeUserFromGroup(groupId, userId))
    }

    _deleteUser = (userId) => {
        this.props.dispatch(deleteUser(userId))
    }

    closeGroup = (group) => {
        if (this.state.selectedGroup.id === group.id) {
            this.setState({selectedGroup: undefined})
        }
    }

    makeUserAdmin = (userId) => {
        this.props.dispatch(addUserRole(userId, 'GROUP_ADMINISTRATOR'))
    }

    makeUserNotAdmin = (userId) => {
        this.props.dispatch(removeUserRole(userId, 'GROUP_ADMINISTRATOR'))
    }

    render() {
        //console.log('GroupsView', this.props)

        return (
            <div>
                {this.state.showCreateGroupModal && <CreateGroupModal
                    onCancel={() => this.setState({showCreateGroupModal: false})}
                    dispatch={this.props.dispatch} />}
                {this.state.showAddUserModal && this.state.selectedGroup && <AddUserModal
                    group={this.state.selectedGroup}
                    onCancel={() => this.setState({showAddUserModal: false})}
                    dispatch={this.props.dispatch} />}

                <div className="groups-container">
                    <Grid fluid>
                        <Row>
                            <Col xs={12} md={6} className="groups-header">CURRENT MAINTENANCE AGENCIES</Col>
                            <Col xs={12} md={6} style={{textAlign: 'right'}} className="new-agency">
                                <img src={blueAdd} alt="" style={{width: '12px', height: '12px'}}/>
                                <button className="link no-underline"  onClick={() => this.setState({showCreateGroupModal: true})}>Create new maintenance agency</button>
                            </Col>
                        </Row>

                        {(this.props.groups || []).map(g => <GroupView
                            key={`${g.group.id}_${Math.random()}`}
                            group={g.group}
                            users={g.users}
                            selected={(this.state.selectedGroup || {}).id === g.group.id}
                            selectGroup={this.selectGroup}
                            closeGroup={this.closeGroup}
                            removeUserFromGroup={this._removeUserFromGroup}
                            deleteUser={this._deleteUser}
                            addUserClicked={() => this.setState({showAddUserModal: true})}
                            dispatch={this.props.dispatch}
                            makeUserAdmin={this.makeUserAdmin}
                            makeUserNotAdmin={this.makeUserNotAdmin}
                        />)}
                    </Grid>
                </div>
            </div>
        );
    }
}









// WEBPACK FOOTER //
// ./src/components/admin/groups/GroupsView.jsx